import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const GetContactUs = () => {
  const { id } = useParams();
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const server_url = process.env.REACT_APP_API_URI;

  useEffect(() => {
    fetch(`${server_url}/contactUs/${id}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch contact details');
        }
        return response.json();
      })
      .then((data) => {
        if (data && data.data) {
          setContact(data.data);
        } else {
          throw new Error('Contact details not found');
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Fetch error:', err);
        setError('Failed to fetch contact details.');
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p>Loading Contact Details...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Contact Details</h2>
      <div className="border p-4 rounded-lg shadow">
        <div className="mb-2">
          <strong>Name:</strong> {contact.name}
        </div>
        <div className="mb-2">
          <strong>Email:</strong> {contact.email}
        </div>
        <div className="mb-2">
          <strong>User Type:</strong> {contact.userType}
        </div>
        <div className="mb-2">
          <strong>Message:</strong>
          <p className="border p-2 mt-1 bg-gray-100 rounded">
            {contact.message}
          </p>
        </div>
      </div>
    </div>
  );
};

export default GetContactUs;
